module.exports = __webpack_public_path__ + "static/media/gsb-iconHotel&Travel.9507fb85.svg";